import {AutoOrange, JpegRed, PngOrange, WebpGreen} from 'src/ui-components/Iconpack';
import React from 'react';

interface FormatSubMenuProps {
    title: string;
    icon: React.FC;
    value: string;
    display: boolean;
}

export const FormatSubMenuItems: FormatSubMenuProps[] = [
    {
        title: 'PNG',
        icon: PngOrange,
        value: 'png',
        display: true,
    },
    {
        title: 'WEBP',
        icon: WebpGreen,
        value: 'webp',
        display: true,
    },
    {
        title: 'JPEG',
        icon: JpegRed,
        value: 'jpeg',
        display: true,
    },
    {
        title: 'AUTO',
        icon: AutoOrange,
        value: 'auto',
        display: true,
    },
];
